import { useEffect, useRef } from 'react';

export default function useIntersectionObserver({
  active,
  onIntersection,
}: {
  active: boolean;
  onIntersection: () => void;
}): any {
  const ref = useRef<any>();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting && active) {
        onIntersection();
      }
    });

    if (!ref.current) return;
    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [ref, active, onIntersection]);

  return ref;
}
